<div class="year-picker">
  <button type="button" mat-icon-button (click)="previousYear()" aria-label="Previous year">
    <mat-icon>keyboard_arrow_left</mat-icon>
  </button>
  <button type="button" class="year-picker__label" (click)="yearPicker.open()" aria-label="Select year">
    {{ year() }}
  </button>
  <button type="button" mat-icon-button (click)="yearPicker.open()" aria-label="Open year picker">
    <mat-icon>event</mat-icon>
  </button>
  <button type="button" mat-icon-button (click)="nextYear()" aria-label="Next year">
    <mat-icon>keyboard_arrow_right</mat-icon>
  </button>
  <div class="year-picker__hidden">
    <input matInput [matDatepicker]="yearPicker" readonly />
    <mat-datepicker #yearPicker startView="multi-year" [startAt]="startDate()"
      (yearSelected)="onYearSelected($event, yearPicker)">
    </mat-datepicker>
  </div>
</div>
